import {createReferralProgramResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ReferralProgramSchema = z.object({
  referralRedirectionURL: z.string().nullable(),
  referringCustomerRewardID: z.string().nullable(),
  referredFriendRewardID: z.string().nullable(),
  referringCustomerRewardName: z.string().nullable(),
  referredFriendRewardName: z.string().nullable(),
  status: z.number(),
})

export const ReferralProgramSchemaResponse =
  createReferralProgramResponseSchema(ReferralProgramSchema)

export type ReferralProgram = z.infer<typeof ReferralProgramSchema>
export type ReferralProgramResponse = z.infer<typeof ReferralProgramSchemaResponse>
